import * as Yup from 'yup';

import { Strings } from '@app/constants';

// ---------------addDepartmentSchema-------------
export const addDepartmentSchema = Yup.object()
  .shape({
    name: Yup.string().trim().required(Strings.validation.fieldRequired(Strings.field.name)),
    desc: Yup.string(),
  })
  .required();
